import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const openCookieSettings = () => {
    if (typeof window === 'undefined') {
      return;
    }

    if (
      window.vmCookieConsent &&
      typeof window.vmCookieConsent.openPreferences === 'function'
    ) {
      window.vmCookieConsent.openPreferences();
      return;
    }

    window.dispatchEvent(new Event('vm:open-cookie-consent'));
  };

  return (
    <footer className="footer">
      <div className="footer-dropdowns">
        <div className="dropdown">
          <span>Coding Projects</span>
          <div className="dropdown-content">
            <Link to="/games">Games</Link>
            <Link to="/math">Math</Link>
            <Link to="/drawing">Drawing</Link>
            <Link to="/web-development">Vivaan's Web Development</Link>
          </div>
        </div>
        <div className="dropdown">
          <span>Piano Covers</span>
          <div className="dropdown-content">
            <Link to="/pop">Pop</Link>
            <Link to="/hindi_songs">Hindi Songs</Link>
            <Link to="/favorite_songs">Favorite Songs</Link>
          </div>
        </div>
        <div className="dropdown">
          <span>Cooking Recipes</span>
          <div className="dropdown-content">
            <Link to="/snacks">Snacks</Link>
            <Link to="/drinks">Drinks</Link>
            <Link to="/meals">Meals</Link>
          </div>
        </div>
      </div>
      <div className="footer-links">
        <Link to="/privacy-policy">Privacy Policy</Link>
        <Link to="/terms-and-conditions">Terms & Conditions</Link>
        <button
          type="button"
          className="footer-cookie-button"
          onClick={openCookieSettings}
        >
          Cookie Settings
        </button>
      </div>
    </footer>
  );
};

export default Footer;
